import React, { useEffect, useState } from "react";

// Components
import { COLOR_APP } from "../../constants";
import {
  CREATE_UNIT,
  DELETE_UNIT,
  UPDATE_UNIT,
} from "../../graphql/unit/mutation";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useQueryUnitData } from "../../services/unitService/queries";

// Libraries
import { Button, Table, Form, Modal, Row, Spinner } from "react-bootstrap";
import { useMutation } from "@apollo/client";
import moment from "moment";

// Icons
import { BiRuler } from "react-icons/bi";
import { IoMdAdd } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import ModalConfirmComponent from "../../components/ModalConfirmComponent";
import usePermission from "../../helpers/usePermission";

//* ໜ້າຈັດການຫົວໜ່ວຍສິນຄ້າ — ໂຄງສ້າງຄືກັບ CategoryLists ແຕ່ບໍ່ມີລາຍລະອຽດ
export default function UnitLists({ shopId }) {
  //* ສິດຍ່ອຍຂອງ "ຈັດການສິນຄ້າ" — ບໍ່ມີສິດ → ຊ່ອນປຸ່ມ
  const canCreate = usePermission("PRODUCTS_CREATE");
  const canUpdate = usePermission("PRODUCTS_UPDATE");
  const canDelete = usePermission("PRODUCTS_DELETE");
  const [isAddModal, setIsAddModal] = useState(false);
  const [isDelModal, setIsDelModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [search, setSearch] = useState();
  const [unitName, setUnitName] = useState();
  const [unitDatas, setUnitDatas] = useState([]);
  const [unitTotal, setUnitTotal] = useState(0);
  const [prepareId, setPrepareId] = useState();

  const { queryUnitDatas, loadUnitData, loadingUnitDatas } = useQueryUnitData();

  // GraphQL Clients
  const [createUnit, { loading: loadingCGR }] = useMutation(CREATE_UNIT);
  const [updateUnit, { loading: loadingUGR }] = useMutation(UPDATE_UNIT);
  const [deletedUnit, { loading: loadingDelete }] = useMutation(DELETE_UNIT);

  // useEffect Hooks
  useEffect(() => {
    fetchUnitData();
  }, [search]);

  useEffect(() => {
    if (loadUnitData) {
      setUnitDatas(loadUnitData?.units?.data ?? []);
      setUnitTotal(loadUnitData?.units?.total);
    }
  }, [loadUnitData]);

  // Handle fetch data
  const fetchUnitData = async () => {
    await queryUnitDatas({ _name: search });
  };

  const onCloseModal = () => {
    setUnitName("");
    setIsAddModal(false);
    setValidated(false);
    setIsDelModal(false);
    setEditMode(false);
  };

  // create unit data
  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const form = e.currentTarget;
      if (loadingCGR) return;

      if (form.checkValidity() === true) {
        e.stopPropagation();
        const response = await createUnit({
          variables: {
            data: {
              name: unitName,
              shop: shopId,
            },
          },
        });

        if (response?.data?.createUnit?.message === "CREATED_SUCCESS") {
          fetchUnitData();
          onCloseModal();
        }
        return;
      }

      setValidated(true);
    } catch (error) {
      setValidated(false);
      console.error("Error creating unit:", error);
    }
  };

  // update unit
  const onUpdateUnit = async (e) => {
    e.preventDefault();
    try {
      if (loadingUGR) return;
      await updateUnit({
        variables: {
          where: {
            id: prepareId,
          },
          data: {
            name: unitName,
          },
        },
      }).then(() => {
        onCloseModal();
        fetchUnitData();
      });
    } catch (error) {
      console.error(error);
    }
  };

  // confirm delete unit data
  const onDeleteUnit = async () => {
    try {
      if (loadingDelete) return;
      const res = await deletedUnit({
        variables: {
          where: {
            id: prepareId,
          },
        },
      });

      if (res?.data?.deleteUnit?.message === "DELETED_SUCCESS") {
        onCloseModal();
        fetchUnitData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // edit unit
  const handleEdit = (data) => {
    setEditMode(true);
    setIsAddModal(true);
    setUnitName(data?.name);
    setPrepareId(data?.id);
  };

  // prepare confirm modal deleted
  const handleDelete = (id) => {
    setIsDelModal(true);
    setPrepareId(id);
  };

  return (
    <>
      <div className="d-flex flex-column p-4 w-100">
        <div className="d-flex gap-2 justify-content-start align-items-center">
          <BiRuler style={{ fontSize: 27 }} />
          <h5>ລາຍການຫົວໜ່ວຍສິນຄ້າ [{unitTotal ?? 0}]</h5>
        </div>
        <br />
        <div className="d-flex w-100 gap-4 justify-content-between align-items-center">
          <Form.Group className="mb-3 w-100" controlId="units">
            <Form.Label>ຄົ້ນຫາ</Form.Label>
            <Form.Control
              value={search}
              onChange={(e) => setSearch(e?.target?.value)}
              type="text"
              placeholder="ປ້ອນຊື່ຫົວໜ່ວຍ..."
            />
          </Form.Group>
          {canCreate && (
          <Button
            style={{
              background: COLOR_APP,
              marginTop: 15,
              color: "#fff",
              minWidth: 200,
            }}
            onClick={() => setIsAddModal(true)}>
            <IoMdAdd />
            ເພິ່ມ
          </Button>
          )}
        </div>
        <div className="py-2">
          {loadingUnitDatas && !loadUnitData ? (
            <LoadingSpinner />
          ) : (
            <Table striped bordered>
              <thead>
                <tr>
                  <th style={{ border: "none" }}>ລຳດັບ</th>
                  <th style={{ border: "none" }}>ຫົວໜ່ວຍສິນຄ້າ</th>
                  <th style={{ border: "none" }}>ວັນທີ,ເດືອນ,ປີ</th>
                  <th style={{ border: "none", textAlign: "right" }}>ຈັດການ</th>
                </tr>
              </thead>
              <tbody>
                {unitDatas.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.name ?? "-"}</td>
                    <td>{moment(item?.createdAt).format("DD/MM/YYYY")}</td>
                    <td style={{ width: 200, textAlign: "right" }}>
                      {canUpdate && (
                      <Button
                        variant="outline-secondary"
                        onClick={() => handleEdit(item)}>
                        <FaEdit />
                        ແກ້ໄຂ
                      </Button>
                      )}
                      &nbsp;
                      {canDelete && (
                      <Button
                        variant="outline-danger"
                        onClick={() => handleDelete(item?.id)}>
                        <MdDelete />
                        ລົບ
                      </Button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>
      </div>

      <Modal centered show={isAddModal} onHide={onCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editMode ? "ແກ້ໄຂຫົວໜ່ວຍສິນຄ້າ" : "ເພິ່ມຫົວໜ່ວຍສິນຄ້າ"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={editMode ? onUpdateUnit : handleSubmit}>
            <Row className="mb-3 w-100">
              <Form.Group controlId="unitName" className="w-100">
                <Form.Label>ຊື່ຫົວໜ່ວຍສິນຄ້າ</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="ຕົວຢ່າງ: ຜືນ, ຄູ່, ອັນ..."
                  className="w-100"
                  value={unitName}
                  onChange={(e) => setUnitName(e?.target?.value)}
                />
                <Form.Control.Feedback type="invalid">
                  ກາລຸນາປ້ອນຂໍ້ມູນກ່ອນ!
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <div className="d-flex gap-2">
              <Button
                variant="outline-secondary"
                type="button"
                onClick={onCloseModal}>
                ຍົກເລິກ
              </Button>
              {editMode ? (
                <Button
                  type="submit"
                  style={{ background: COLOR_APP, color: "#fff" }}>
                  {loadingUGR && <Spinner />} ແກ້ໄຂ
                </Button>
              ) : (
                <Button
                  type="submit"
                  style={{ background: COLOR_APP, color: "#fff" }}>
                  {loadingCGR && <Spinner />} ບັນທຶກ
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* confirm deleted unit */}
      <ModalConfirmComponent
        showConfirmModal={isDelModal}
        handleCancel={() => setIsDelModal(false)}
        handleConfirm={onDeleteUnit}
        loadingConfirm={loadingDelete}
        title="ແຈ້ງເຕືອນ"
        text={"ທ່ານຕ້ອງການລົບຫົວໜ່ວຍນີ້ແທ້ບໍ່?"}
      />
    </>
  );
}
